import { call, all, put, takeEvery } from "@redux-saga/core/effects";
import { raiseComplaint } from "../../Services/api";
import {
  getComplaint,
  setComplaintStatusToOpen,
  // getExistingComplaint,
  updateLinkCompliant
} from "../../Services/database";
import { getFileUrl } from "../../Services/storage";
import { isValidArray, isValidObject } from "../../Services/validators";
import { setErrorStatus, setSuccessStatus } from "../status/action";
import store from "../store";
import {
  clearExistingComplaint,
  setSelectedComplaint
  // updateLinkComplaint
} from "./action";
import { setSelectedLocation } from "../locations/action";

export const actionTypes = {
  CREATE_COMPLAINTS: "CREATE_COMPLAINTS",
  SET_COMPLAINTS_DATA: "SET_COMPLAINTS_DATA",
  SET_OFFLINE_COMPLAINTS: "SET_OFFLINE_COMPLAINTS",
  SET_SELECTED_COMPLAINT: "SET_SELECTED_COMPLAINT",
  UPDATE_LINK_COMPLAINT: "UPDATE_LINK_COMPLAINT",
  SET_COMPLAINTS_FILTER: "SET_COMPLAINTS_FILTER",
  SET_COMPLAINTS_SEARCH_KEY: "SET_COMPLAINTS_SEARCH_KEY",
  SET_COMPLAINTS_SORT_BY: "SET_COMPLAINTS_SORT_BY",
  SHOW_SELECTED_EXISTING_COMPLAINT: "SHOW_SELECTED_EXISTING_COMPLAINT",
  REOPEN_COMPLAINT: "REOPEN_COMPLAINT",
  SET_COMPLAINTS_COUNT: "SET_COMPLAINTS_COUNT",
  FETCH_SELECTED_COMPLAINTS_ASSETS: "FETCH_SELECTED_COMPLAINTS_ASSETS"
};

function* setComplaintsWorker(action) {
  try {
    yield setComplaintsLoading(true);

    yield put({
      type: "PUT_COMPLAINTS_DATA",
      payload: {
        data: action.payload.complaints
      }
    });
    const selectedComplaint = store.getState().complaints?.selectedComplaint;
    if (isValidObject(selectedComplaint)) {
      yield setSelectedComplaint(selectedComplaint.documentId);
    }

    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);
    setErrorStatus(error);
  }
}

function* setComplaintsCountWorker(action) {
  try {
    yield put({
      type: "PUT_COMPLAINTS_COUNT",
      payload: {
        count: action.payload.count
      }
    });
  } catch (error) {
    yield setComplaintsLoading(false);
    setErrorStatus(error);
  }
}

function* createComplaintWorker(action) {
  try {
    yield setRaiseComplaintsLoading(true);
    const formData = action.payload.data;
    const profileData = store.getState().profile.data;
    const accessToken = store.getState().auth.data.accessToken;

    if (formData?.issue?.length > 0 && accessToken) {
      let existingOpenComplaints = [];
      let raiseComplaintResult = null;
      for (let index = 0; index < formData.issue.length; index++) {
        // if (action.payload.ieAccess) {
        //   const existingComplaints = yield getExistingComplaint(
        //     formData?.locationId,
        //     formData.issue?.[index]
        //   );
        //   if (existingComplaints.length > 0) {
        //     existingOpenComplaints = [
        //       ...existingOpenComplaints,
        //       ...existingComplaints
        //     ];
        //     const complaintLinkData = {
        //       source: {
        //         type: "Others"
        //       },
        //       issuedAt: +new Date(),
        //       userDetails: {
        //         name: profileData.name,
        //         phoneNumber: profileData.phoneNumber
        //       }
        //     };
        //     for (const compliantData of existingComplaints) {
        //       if (
        //         !isValidArray(compliantData?.issuedBy?.linkedWith) ||
        //         !compliantData?.issuedBy?.linkedWith?.some(
        //           (data) =>
        //             data?.userDetails?.phoneNumber === profileData.phoneNumber
        //         )
        //       ) {
        //         updateLinkComplaint(
        //           compliantData?.documentId,
        //           isValidArray(compliantData?.issuedBy?.linkedWith)
        //             ? [
        //                 ...compliantData?.issuedBy?.linkedWith,
        //                 complaintLinkData
        //               ]
        //             : [complaintLinkData]
        //         );
        //       }
        //     }
        //     continue;
        //   }
        // }

        let data = new FormData();
        if (isValidArray(formData.mediaData)) {
          for (let i = 0; i < formData.mediaData.length; i++) {
            if (formData.mediaData[i]) {
              data.append("files", formData.mediaData[i]);
            }
          }
        }

        if (action.payload.ieAccess) {
          data.append(
            "penaltyClause",
            formData.issue?.[index]?.split(".")?.[1]?.trim() ||
              formData.issue?.[index]
          );
          data.append("category", formData.description);
        } else {
          data.append("category", formData.issue?.[index]);
        }

        data.append("createdAt", JSON.stringify(+new Date()));
        data.append(
          "issuedBy",
          JSON.stringify({
            issuedAt: +new Date(),
            type: formData.employeeType || "customerSupport",
            userDetails: {
              name: profileData?.name,
              employeeId: profileData?.employeeId,
              phoneNumber:
                profileData?.phoneNumber.replace("+91", "")?.length === 10
                  ? profileData?.phoneNumber
                  : ""
            },
            ...(formData.employeeType !== "independentEngineer"
              ? {
                  linkedWith: [
                    {
                      source: {
                        type: formData.sourceType,
                        ...(formData.sourceType === "ExoTel Call"
                          ? { callId: formData.callId }
                          : {})
                      },
                      issuedAt: +new Date(),
                      userDetails: {
                        name: formData.name,
                        ...(formData.phoneNumber.replace("+91", "")?.length ===
                        10
                          ? { phoneNumber: formData.phoneNumber }
                          : {})
                      }
                    }
                  ]
                }
              : {})
          })
        );

        if (formData.locationId !== "") {
          data.append("locationId", formData.locationId);
        } else {
          let error = new Error("Invalid LocationId");
          error.code = "custom";
          throw error;
        }

        data.append(
          "status",
          JSON.stringify({
            currentStatus: "OPEN",
            updatedAt: +new Date()
          })
        );

        if (isValidArray(formData.turnaround)) {
          data.append("turnaround", formData.turnaround[index]);
        }

        raiseComplaintResult = yield raiseComplaint(data, accessToken);
      }

      if (action.payload.navigate && existingOpenComplaints.length === 0) {
        action.payload.navigate("/complaint");
      }

      if (raiseComplaintResult?.status === "offline") {
        setErrorStatus({
          code: "custom",
          message: raiseComplaintResult?.message
        });
      } else if (raiseComplaintResult?.success === true) {
        setSuccessStatus("Complaint Created Successfully");
      }

      if (existingOpenComplaints.length > 0) {
        yield put({
          type: "PUT_EXISTING_COMPLAINTS",
          payload: { existingComplaints: existingOpenComplaints }
        });
        action.payload.navigate("/raiseComplaint/success");
      }
    }

    yield setRaiseComplaintsLoading(false);
  } catch (error) {
    yield setRaiseComplaintsLoading(false);
    setErrorStatus(error);
  }
}

function* updateLinkComplaintWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const profileData = store.getState().profile.data;
    const isIndependentEngineer =
      store.getState().auth?.claims?.moduleAccess?.independentEngineer;

    const data = action.payload.data;

    yield updateLinkCompliant(action.payload.complaintId, {
      "issuedBy.linkedWith": data,
      "status.updatedAt": data?.issuedAt,
      latestUpdate: {
        description: `Linked with ${data.userDetails?.phoneNumber || ""} ${
          data.userDetails?.name || ""
        }`,
        updatedAt: data?.issuedAt,
        updatedBy: {
          employeeName: profileData.name,
          employeeId: profileData.employeeId,
          phoneNumber: profileData.phoneNumber
        }
      }
    });
    const updatedComplaint = yield getComplaint(
      action.payload.complaintId,
      isIndependentEngineer
    );
    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: { data: updatedComplaint }
    });

    yield setSuccessStatus("Linked successfully");

    yield setComplaintsLoading(false);
  } catch (error) {
    console.error("linkComplaintWorker", error);
    setErrorStatus(error);
    yield setComplaintsLoading(false);
  }
}

function* setFilterWorker(action) {
  try {
    yield put({
      type: "PUT_FILTER",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    console.error("setFilterWorker", error);
    setErrorStatus(error);
  }
}

function* setSearchKeyWorker(action) {
  try {
    yield put({
      type: "PUT_SEARCH_KEY",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* setSortByWorker(action) {
  try {
    yield put({
      type: "PUT_SORT_BY",
      payload: { data: action.payload.data }
    });
  } catch (error) {
    setErrorStatus(error);
  }
}

function* setOfflineComplaintsWorker(action) {
  yield put({
    type: "PUT_OFFLINE_COMPLAINTS",
    payload: action.payload
  });
}

function* reopenComplaintWorker(action) {
  try {
    yield setComplaintsLoading(true);
    yield setComplaintStatusToOpen(action.payload.data, action.payload.files);
    setSuccessStatus("Complaint reopened successfully");
    action.payload.navigate("/complaints");
    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);
    setErrorStatus(error);
  }
}

function* showSelectedExistingComplaintWorker(action) {
  try {
    yield setSelectedComplaint(action.payload.data.documentId);
    action.payload.navigate(`/complaints/${action.payload.data.documentId}`);
    clearExistingComplaint();
  } catch (error) {
    setErrorStatus(error);
  }
}

function* fetchComplaintsAssetsWorker(action) {
  try {
    yield setComplaintsLoading(true);
    const selectedComplaint = store.getState().complaints?.selectedComplaint;

    if (!isValidObject(selectedComplaint)) {
      yield setComplaintsLoading(false);
      return;
    }

    const updatedComplaint = { ...selectedComplaint };
    let rootProofUpdated = false;
    let updatesChanged = false;

    if (isValidArray(updatedComplaint.assets) && !updatedComplaint.proof) {
      const fileResults = yield all(
        updatedComplaint.assets.map((asset) => call(getFileUrl, asset))
      );

      const images = [];
      let fileSrc = {};

      for (const file of fileResults) {
        if (file.type === "image") {
          images.push(file.url);
        } else if (file.type === "audio") {
          fileSrc.audio = file.url;
        }
      }

      updatedComplaint.fileSrc = {
        ...fileSrc,
        ...(images.length ? { images } : {})
      };

      rootProofUpdated = true;
    }

    const updates = selectedComplaint.latestUpdate || [];
    const newUpdates = yield all(
      updates.map(function* (update) {
        const proof = update.proof || [];
        const assetCount =
          (update.assets?.images?.length || 0) + (update.assets?.audio ? 1 : 0);

        if (proof.length === assetCount) {
          return update;
        }

        const fileResults = yield all(proof.map((p) => call(getFileUrl, p)));

        const images = [];
        let fileSrc = {};

        for (const file of fileResults) {
          if (file.type === "image") {
            images.push(file.url);
          } else if (file.type === "audio") {
            fileSrc.audio = file.url;
          }
        }

        updatesChanged = true;

        return {
          ...update,
          fileSrc: {
            ...fileSrc,
            ...(images.length ? { images } : {})
          }
        };
      })
    );

    if (updatesChanged) {
      updatedComplaint.latestUpdate = newUpdates;
    }

    if (rootProofUpdated || updatesChanged) {
      yield put({
        type: "PUT_SELECTED_COMPLAINT",
        payload: { data: updatedComplaint }
      });
    }

    yield setComplaintsLoading(false);
  } catch (error) {
    yield setComplaintsLoading(false);

    setErrorStatus(error, "fetchComplaintsAssetsWorker");
  }
}

function* setSelectedComplaintWorker(action) {
  try {
    yield setComplaintsLoading(true);

    const complaintId = action.payload.complaintId;
    if (!complaintId) {
      yield put({
        type: "PUT_SELECTED_COMPLAINT",
        payload: { data: null }
      });
      yield setComplaintsLoading(false);
      return;
    }

    const complaintsData = store.getState().complaints.data;
    let selectedComplaint = complaintsData?.[complaintId];

    if (!isValidObject(selectedComplaint)) {
      selectedComplaint = yield getComplaint(complaintId);
      if (!selectedComplaint) {
        if (action.payload.navigate) {
          action.payload.navigate("/complaints");
        }

        yield setComplaintsLoading(false);
        return setErrorStatus({
          code: "custom",
          message: "Complaint resolved or not found"
        });
      }
    }

    yield put({
      type: "PUT_SELECTED_COMPLAINT",
      payload: { data: selectedComplaint }
    });

    setSelectedLocation(selectedComplaint.location.id);

    yield setComplaintsLoading(false);
  } catch (error) {
    console.error("setSelectedComplaintWorker", error);
    yield setComplaintsLoading(false);
    setErrorStatus(error, "setSelectedComplaintWorker");
  }
}

export default function* complaintWatcher() {
  yield all([
    takeEvery("SET_COMPLAINTS_DATA", setComplaintsWorker),
    takeEvery("CREATE_COMPLAINTS", createComplaintWorker),
    takeEvery("SET_OFFLINE_COMPLAINTS", setOfflineComplaintsWorker),
    takeEvery("SET_SELECTED_COMPLAINT", setSelectedComplaintWorker),
    takeEvery("UPDATE_LINK_COMPLAINT", updateLinkComplaintWorker),
    takeEvery("SET_COMPLAINTS_FILTER", setFilterWorker),
    takeEvery("SET_COMPLAINTS_SEARCH_KEY", setSearchKeyWorker),
    takeEvery("SET_COMPLAINTS_SORT_BY", setSortByWorker),
    takeEvery(
      "SHOW_SELECTED_EXISTING_COMPLAINT",
      showSelectedExistingComplaintWorker
    ),
    takeEvery("REOPEN_COMPLAINT", reopenComplaintWorker),
    takeEvery("SET_COMPLAINTS_COUNT", setComplaintsCountWorker),
    takeEvery("FETCH_SELECTED_COMPLAINTS_ASSETS", fetchComplaintsAssetsWorker)
  ]);
}

function* setComplaintsLoading(bool) {
  yield put({
    type: "SET_COMPLAINTS_LOADING",
    payload: {
      loading: bool
    }
  });
}

function* setRaiseComplaintsLoading(bool) {
  yield put({
    type: "SET_RAISE_COMPLAINTS_LOADING",
    payload: {
      loading: bool
    }
  });
}
